<script setup lang="ts">
import { PhArrowLeft as ArrowLeft, PhHeartbeat as Heartbeat } from "@phosphor-icons/vue";
import { computed, ref } from "vue";
import BrandBar from "./BrandBar.vue";
import HomeButton from "./HomeButton.vue";
import { stateQuestions } from "../data/content";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
const index = ref(0);
const locked = ref(false);
const question = computed(() => stateQuestions[index.value]);
function choose(value: string) {
  if (locked.value) return;
  store.chooseStateAnswer(question.value.id, value);
  store.track("state_answer", { question_id: question.value.id, option_id: value, selected: true });
  locked.value = true;
  window.setTimeout(() => {
    if (index.value < stateQuestions.length - 1) index.value += 1;
    else store.submitState();
    locked.value = false;
  }, 320);
}

function isSelected(value: string) {
  return store.stateAnswers[question.value.id] === value;
}

function back() {
  if (index.value > 0) index.value -= 1;
  else store.go("result");
}
</script>

<template>
  <section class="screen screen--state">
    <header class="subpage-header">
      <button class="icon-button" aria-label="返回" @click="back"><ArrowLeft :size="22" weight="bold" /></button>
      <BrandBar compact label="工位回血起步方案" />
      <HomeButton />
    </header>

    <div class="state-intro">
      <span><Heartbeat :size="22" weight="fill" /></span>
      <p><strong>再回答 2 个问题，生成你的工位回血起步方案。</strong><br />不会改变你的牛马角色结果。</p>
    </div>

    <div class="question-stage question-stage--state">
      <p class="eyebrow">状态确认 · {{ index + 1 }}/2</p>
      <h1>{{ question.prompt }}</h1>
      <div class="state-options">
        <button
          v-for="(option, optionIndex) in question.options"
          :key="option[0]"
          :class="{ selected: isSelected(option[0]), 'state-option--simple': question.id !== 'S01' }"
          :aria-pressed="isSelected(option[0])"
          @click="choose(option[0])"
        >
          <span class="state-option-visual">{{ String.fromCharCode(65 + optionIndex) }}</span>
          <span class="state-option-copy">{{ option[1] }}</span>
        </button>
      </div>
    </div>

    <button class="text-button state-skip" @click="store.go('result')">暂时不看方案</button>
  </section>
</template>
